// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sentences-and-more-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.section-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.section {
  padding: 20px;
  height: auto;
}

.section-header {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.section-header-text {
  display: flex;
  flex-direction: column;
}

.new-card-container {
  display: flex;
  flex-direction: row;
  padding: 10px;
}

.new-card-content {
  display: flex;
  align-items: center;
  background-color: rgb(255, 255, 255);
  border: solid 1px rgba(33, 8, 84, 0.16);
  border-radius: 4px;
}

.new-card-content input {
  padding: 10px;
}

:host ::ng-deep app-word-group-cards .content-card {
  border-width: 0;
  border: 1px solid #dfdee5;
  display: inline-block;
  padding: 13px 0 !important;
  padding-right: 8px !important;
}
.dark-theme :host ::ng-deep app-word-group-cards .content-card {
  border: 1px solid rgba(211, 211, 211, 0.3) !important;
}
:host ::ng-deep app-word-group-cards .content-card .drag-indicator, :host ::ng-deep app-word-group-cards .content-card mat-icon.more-vert {
  cursor: pointer;
  color: #dfdee5;
}
.dark-theme :host ::ng-deep app-word-group-cards .content-card .drag-indicator, .dark-theme :host ::ng-deep app-word-group-cards .content-card mat-icon.more-vert {
  color: rgba(211, 211, 211, 0.3) !important;
}
:host ::ng-deep app-word-group-cards .content-card .drag-indicator {
  padding-left: 4px;
  top: 0;
  position: relative;
}
:host ::ng-deep app-word-group-cards .content-card .card-text {
  padding-left: 16px;
}
:host ::ng-deep app-word-group-cards .content-card .card-text.orderable {
  padding-left: 8px;
  padding-right: 8px;
}
:host ::ng-deep app-word-group-cards .content-card mat-icon {
  position: relative;
  top: 0;
}
:host ::ng-deep app-word-group-cards table#wordGroupItems tr {
  margin: 0;
  border-radius: 4px;
  margin-bottom: 8px !important;
  margin-right: 8px !important;
}
:host ::ng-deep app-word-group-cards table#wordGroupItems tr > .content-card {
  margin-bottom: 8px;
  display: inline-block;
}
:host ::ng-deep app-word-group-cards table#wordGroupItems tr > .content-card > div {
  display: flex;
}
.dark-theme :host ::ng-deep .alert-dialog-message {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/core/components/workbooks/workbook-builder/sentences-and-more/sentences-and-more.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAGA;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;AAAF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAIA;EACE,aAAA;EACA,YAAA;AADF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAAF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAjCF;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,uCAAA;EACA,kBAAA;AAhCF;;AAkCA;EACE,aAAA;AA/BF;;AA4CI;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EAKA,0BAAA;EACA,6BAAA;AA7CN;AAwCM;EAEE,qDAAA;AAvCR;AA2CM;EACE,eAAA;EACA,cAAA;AAzCR;AA0CQ;EACE,0CAAA;AAxCV;AA2CM;EACE,iBAAA;EACA,MAAA;EACA,kBAAA;AAzCR;AA2CM;EACE,kBAAA;AAzCR;AA0CQ;EACE,iBAAA;EACA,kBAAA;AAxCV;AA2CM;EACE,kBAAA;EACA,MAAA;AAzCR;AA6CM;EACE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;AA3CR;AA+CQ;EACE,kBAAA;EACA,qBAAA;AA7CV;AA8CU;EACE,aAAA;AA5CZ;AAoDI;EACE,YAAA;AAlDN","sourcesContent":["// @import \"../../../../../styles.scss\";\n// @import \"../../../../../component_variable.scss\";\n.sentences-and-more-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.section-container{\n  background-color: white;\n  width: 100%;\n  border-radius: 8px;\n}\n.container{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n// .background{\n//   background-color: $primary-light;\n// }\n.section{\n  padding: 20px;\n  height: auto;\n}\n.section-header{\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.section-header-text{\n  display: flex;\n  flex-direction: column;\n}\n// .divider{\n//   width: 100%;\n//   height: 1px;\n//   border: solid 1px $whizzimo-border-transparent;\n// }\n// .section-button{\n//   color: $primary;\n// }\n// .content-card{\n//   display: flex;\n//   align-items: center;\n//   padding: 10px;\n//   border-radius: 4px;\n//   border: solid 1px rgba(33, 8, 84, 0.16);\n//   background-color: $whizzimo-modal-background;\n//   span{\n//     &:first-child{\n//       color: rgba($whizzimo-black-white, 0.87);\n//     }\n//   }\n//   button{\n//     mdc-button__label{\n//       color: rgba($whizzimo-black-white, 0.87);\n//     }\n//   }\n// }\n// .card-text{\n//   font-size: 24px;\n//   font-weight: bold;\n//   font-stretch: normal;\n//   font-style: normal;\n//   line-height: 1;\n//   letter-spacing: normal;\n//   color: $primary-dark;\n// }\n.new-card-container{\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n}\n.new-card-content{\n  display: flex;\n  align-items: center;\n  background-color: rgb(255, 255, 255);\n  border: solid 1px rgba(33, 8, 84, 0.16);\n  border-radius: 4px;\n}\n.new-card-content input{\n  padding: 10px;\n}\n// .new-card-button{\n//   border-top-right-radius: 4px;\n//   border-bottom-right-radius: 4px;\n//   color: $primary;\n//   border-color: $primary;\n//   padding: 10px;\n// }\n\n\n:host ::ng-deep {\n  app-word-group-cards {\n    .content-card {\n      border-width: 0;\n      border: 1px solid #dfdee5;\n      display: inline-block;\n      .dark-theme & {\n        // border-width: 0;\n        border: 1px solid rgba(211, 211, 211, 0.3) !important;\n      }\n      padding: 13px 0 !important;\n      padding-right: 8px !important;\n      .drag-indicator, mat-icon.more-vert {\n        cursor: pointer;\n        color: #dfdee5;\n        .dark-theme & {\n          color: rgba(211, 211, 211, 0.3) !important;\n        }\n      }\n      .drag-indicator {\n        padding-left: 4px;\n        top: 0;\n        position: relative;\n      }\n      .card-text {\n        padding-left: 16px;\n        &.orderable {\n          padding-left: 8px;\n          padding-right: 8px;\n        }\n      }\n      mat-icon {\n        position: relative;\n        top: 0;\n      }\n    }\n    table#wordGroupItems {\n      tr {\n        margin: 0;\n        border-radius: 4px;\n        margin-bottom: 8px !important;\n        margin-right: 8px !important;\n        .dark-theme & {\n          // border: 1px solid rgba(211, 211, 211, 0.3);\n        }\n        > .content-card {\n          margin-bottom: 8px;\n          display: inline-block;\n          > div {\n            display: flex;\n          }\n        }\n      }\n    }\n  }\n\n  .alert-dialog-message {\n    .dark-theme & {\n      color: white;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
